import {render} from "react-dom";
import {ToastContainer} from "react-toastify";

import FormLogin from '../_pages/PageLogin';
import ErrorBoundary from "../_lib/components/ErrorBoundary";

(async () => {
    render(<ErrorBoundary>
        <FormLogin/>
        <ToastContainer/>
    </ErrorBoundary>, document.getElementById('component-container'));
})();